"use strict";

module.exports = {
  locationLabel: 'Flying from?',
  parkingFromLabel: 'Parking from',
  parkingToLongLabel: 'Return to collect car',
  parkingToShortLabel: 'Collect car',
  parkingTimeLabel: 'Arrival',
  parkingToTimeLabel: 'Returning',
  flightTimeLabel: 'Flight departs',
  terminalLabel: 'Terminal',
  terminalLinkText: 'Select terminal',
  roomLabel: 'Staying in',
  addRoomLabel: 'Add another room',
  pptsTurnOnLabel: 'Stay on my return',
  pptsTurnOffLabel: 'Stay before I fly',
  daysParkingLabel: 'days parking for 1 car',
  includeAirportParkingLabel: 'Include<span class="hidden-md hidden-sm hidden-xs"> airport</span> parking',
  includeAirportParkingOptionPleaseSelect: 'Please select',
  includeAirportParkingOptionYes: 'Yes please',
  includeAirportParkingOptionNo: 'No thanks',
  searchButtonText: 'Get best prices',
  searchButtonTextHotels: 'Get best prices',
  searchButtonLoadingText: 'Please wait ...',
  lounge7Plus: 'Party of 7 or more people? Group bookings have to be requested with the lounge. Please do not make separate bookings or the lounge will refuse entry.',
  hotelLabels: {
    ho: {
      startDate: 'Hotel check-in',
      endDate: 'Return date',
      startDateHomepageTest: 'Check in (1 night)',
      endDateHomepageTest: 'Collect car'
    },
    hcp: {
      ppts: {
        startDate: 'Parking from',
        endDate: 'Hotel check-in',
        startDateHomepageTest: 'Parking from',
        endDateHomepageTest: 'Check in (1 night)'
      },
      nonPpts: {
        startDate: 'Hotel and Parking check-in',
        endDate: 'Collect car on',
        startDateHomepageTest: 'Check in (1 night)',
        endDateHomepageTest: 'Collect car'
      }
    }
  },
  flightInput: {
    inputLabel: 'Enter flight number',
    placeholder: 'Eg. VS27'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/config/translationConfig.js
// module id = 759
// module chunks = 119